var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-no-wrap"},[_c('v-icon',{staticClass:"mr-2",class:_vm.projectStatus.class},[_vm._v(_vm._s(_vm.projectStatus.icon))]),_c('span',{class:_vm.projectStatus.class},[_vm._v(_vm._s(_vm.projectStatus.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }